import React, { useEffect } from 'react';
import SEO from '@components/Common/SEO/index';
import FAQSection from '@components/v5/FAQSection/index';

import * as styles from '@components/v5/AiEngineeringDetailedCurriculum/detailedCurriculum.module.scss';
import PageHeader from '@components/v5/AiEngineeringDetailedCurriculum/PageHeader';
import Hero from '@components/v5/AiEngineeringDetailedCurriculum/Hero';
import SubNav from '@components/v5/AiEngineeringDetailedCurriculum/SubNav';
import Outline from '@components/v5/AiEngineeringDetailedCurriculum/Outline';
import CurriculumDeepDive from '@components/v5/AiEngineeringDetailedCurriculum/CurriculumDeepDive';
import Ladder from '@components/v5/AiEngineeringDetailedCurriculum/Ladder';
import QuickRef from '@components/v5/AiEngineeringDetailedCurriculum/QuickRef';
import MiniProjects from '@components/v5/AiEngineeringDetailedCurriculum/MiniProjects';
import GuidedProjects from '@components/v5/AiEngineeringDetailedCurriculum/GuidedProjects';
import OptionalBuilds from '@components/v5/AiEngineeringDetailedCurriculum/OptionalBuilds';
import Modules from '@components/v5/AiEngineeringDetailedCurriculum/Modules';
import PreWork from '@components/v5/AiEngineeringDetailedCurriculum/PreWork';
import Band from '@components/v5/AiEngineeringDetailedCurriculum/Band';
import PageFooter from '@components/v5/AiEngineeringDetailedCurriculum/PageFooter';
import { curriculumFaqs } from '@components/v5/AiEngineeringDetailedCurriculum/faqData';

export default function AiEngineeringDetailedCurriculumPage() {
  // Scoped smooth-scroll + scroll-padding for the on-page subnav anchors (so a jump
  // doesn't hide behind the sticky header + subnav), without touching the global
  // html element for every other page on the site.
  useEffect(() => {
    const html = document.documentElement;
    const previousBehavior = html.style.scrollBehavior;
    const previousPadding = html.style.scrollPaddingTop;
    html.style.scrollBehavior = 'smooth';
    html.style.scrollPaddingTop = '120px';
    return () => {
      html.style.scrollBehavior = previousBehavior;
      html.style.scrollPaddingTop = previousPadding;
    };
  }, []);

  return (
    <div className={styles.page}>
      <SEO
        title="Detailed Curriculum & Projects — Fellowship Program in AI Engineering | Crio.Do"
        description="Sprint-by-sprint curriculum and every project of Crio.Do's Fellowship Program in AI Engineering: six 4-week build sprints, a 2-week interview sprint, 17 builds explained in plain language — what each one is, the problem it solves, what you build and how it is measured."
      />

      <PageHeader />
      <Hero />
      <SubNav />
      <Outline />
      <CurriculumDeepDive />
      <Ladder />
      <QuickRef />
      <MiniProjects />
      <GuidedProjects />
      <OptionalBuilds />
      <Modules />
      <PreWork />

      {/* FAQSection is reused as-is (site-standard accordion), so its own classes
          aren't affected by this page's scoped resets even though it's nested here —
          it doesn't use any hyphenated/ported class names, only its own Tailwind ones. */}
      <FAQSection
        id="faq"
        data={curriculumFaqs}
        heading="Questions about the projects"
        description="Every build ships with a lab kit: starter + golden repo, eval harness + golden set, CI auto-grading, rubric, spec &amp; demo templates."
      />

      <Band />
      <PageFooter />
    </div>
  );
}
